var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mt-2"},[_c('EventLog',{attrs:{"organisation":_vm.organisation,"type":"organisation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }